import React from 'react'
import { Link, usePage } from '@inertiajs/inertia-react'
import Layout from '../../Shared/Layout/LayoutAdmin'
import LayoutSiaLearner from '../../Shared/Layout/LayoutSiaLearner'
import Breadcrumbs from '../../Shared/Components/Breadcrumbs'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import { SIA_GOLD_ACTIVE_BG, SIA_GOLD_ACTIVE_TEXT, SIA_NAVY } from '../../constants/siaTheme'

const WELCOME_BODY =
    '¡Hola a todos! Quiero animarlos a aprovechar al máximo nuestra aula virtual. Este espacio está diseñado para su crecimiento, con todo el contenido necesario para que desarrollen nuevas habilidades y conocimientos. Cada material que encuentran aquí es una oportunidad para avanzar y mejorar. Recuerden, la capacitación es clave para abrir nuevas puertas, y el esfuerzo que invierten hoy será su mayor aliado en el futuro.'

const Portada = ({ sections }) => {
    const { sia_use_learner_layout } = usePage().props

    return (
        <>
            {!sia_use_learner_layout && (
                <div className="mb-5 mt-5">
                    <Breadcrumbs currentPath="/admin/sia" />
                </div>
            )}

            {sia_use_learner_layout ? (
                <div className="d-flex justify-content-center pb-10 pt-2 px-2">
                    <div
                        className="w-100 rounded-3 shadow-sm bg-white overflow-hidden"
                        style={{ maxWidth: '920px', border: '1px solid #e8e8e8' }}
                    >
                        <div
                            className="text-center text-white text-uppercase fw-bold py-5 px-4 fs-4"
                            style={{ backgroundColor: SIA_NAVY, letterSpacing: '0.06em' }}
                        >
                            Sistema Integral de Autoaprendizaje
                        </div>
                        <div className="py-10 px-6 px-md-10 text-center">
                            <h2 className="fw-normal text-gray-900 mb-8 fs-2">Bienvenida(o)</h2>
                            <p className="text-gray-800 lh-lg fs-5 mb-2 mx-auto" style={{ maxWidth: '720px' }}>
                                {WELCOME_BODY}{' '}
                                <strong className="text-gray-900">¡Vamos con todo, su éxito está en sus manos!</strong>
                            </p>
                            <p className="text-gray-800 lh-lg fs-5 mt-8 mb-6 mx-auto" style={{ maxWidth: '720px' }}>
                                Inicia con el video de bienvenida para ir desbloqueando tu camino al éxito.
                            </p>
                            <Link
                                href={route('sia.section.show', 'bienvenido-video-de-bienvenida')}
                                className="btn fw-semibold px-6"
                                style={{ backgroundColor: SIA_GOLD_ACTIVE_BG, color: SIA_GOLD_ACTIVE_TEXT, border: 'none' }}
                            >
                                Ver video de bienvenida
                            </Link>
                            <p className="text-uppercase fw-semibold text-gray-900 mt-10 mb-8 fs-6" style={{ letterSpacing: '0.04em' }}>
                                Yireh & Brokers agente de seguros
                            </p>
                            <div className="d-flex flex-wrap justify-content-center align-items-center gap-8 gap-md-12">
                                <img
                                    src="/images/logo-yireh-grande.png"
                                    alt="Yireh & Brokers"
                                    className="object-fit-contain"
                                    style={{ width: '350px' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <>
                    <div
                        className="rounded-2 mb-8 py-6 px-4 text-center text-white"
                        style={{ backgroundColor: SIA_NAVY }}
                    >
                        <div className="text-uppercase fw-bold fs-2 mb-2">Sistema Integral de Autoaprendizaje (SIA)</div>
                        <div className="fs-6 opacity-75">Capacitación · Índice · Videos y temas formativos</div>
                    </div>

                    <div className="card card-flush mb-6">
                        <div className="card-body py-8 px-8">
                            <p className="text-gray-700 fs-5 mb-0 text-center mx-auto" style={{ maxWidth: '720px' }}>
                                Selecciona un módulo para ver videos de YouTube, material descargable alojado en este servidor
                                y contenido organizado por pestañas según el producto.
                            </p>
                        </div>
                    </div>
                </>
            )}

            {!sia_use_learner_layout && (
                <Row className="g-6 mb-10">
                    {sections.map((section) => (
                        <Col md={6} xl={4} key={section.id}>
                            <Card className="h-100 shadow-sm border border-gray-200">
                                <Card.Body className="d-flex flex-column">
                                    <Card.Title className="fs-5 text-gray-900">{section.title}</Card.Title>
                                    <Card.Text className="text-gray-600 flex-grow-1">
                                        {section.description || 'Contenido formativo disponible.'}
                                    </Card.Text>
                                    <div className="d-flex justify-content-between align-items-center mt-4">
                                        <span className="badge badge-light-primary">{section.items_count} recursos</span>
                                        <Link
                                            href={route('sia.section.show', section.slug)}
                                            className="btn btn-sm btn-primary"
                                        >
                                            Abrir
                                        </Link>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            )}

        </>
    )
}

Portada.layout = (page) => {
    if (page.props.sia_use_learner_layout) {
        return <LayoutSiaLearner title="SIA | YIREH">{page}</LayoutSiaLearner>
    }
    return <Layout title="SIA · Portada">{page}</Layout>
}

export default Portada
